// client/src/components/influencer/project/modals/ContractRejectCompleteModal.js
import React from 'react';

function ContractRejectCompleteModal({ open, onClose }) {
  if (!open) return null;

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        {/* 체크 아이콘 */}
        <div style={styles.iconBox}>
          <div style={styles.icon}>✓</div>
        </div>

        {/* 제목 */}
        <h2 style={styles.title}>계약이 거절되었습니다</h2>
        
        {/* 메시지 */}
        <div style={styles.message}>
          광고주에게 거절 의사가 전달되었습니다.
        </div>

        {/* 확인 버튼 */}
        <button style={styles.confirmBtn} onClick={onClose}>
          확인
        </button>
      </div>
    </div>
  );
}

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: 'rgba(0, 0, 0, 0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1004  // ✅ ContractRejectModal(1003)보다 높게
  },
  modal: {
    position: 'relative',
    background: '#fff',
    borderRadius: 12,
    padding: 40,
    maxWidth: 400,
    width: '90%',
    textAlign: 'center'
  },
  iconBox: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 24
  },
  icon: {
    width: 80,
    height: 80,
    borderRadius: '50%',
    background: '#6b7280',  // 회색 (거절이므로 초록색 대신)
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 48,
    fontWeight: 700
  },
  title: {
    fontSize: 24,
    fontWeight: 700,
    marginBottom: 16,
    color: '#111827'
  },
  message: {
    fontSize: 15,
    lineHeight: 1.6,
    color: '#6b7280',
    marginBottom: 32
  },
  confirmBtn: {
    width: '100%',
    padding: '14px',
    background: '#6b7280',
    color: '#fff',
    border: 'none',
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer'
  }
};

export default ContractRejectCompleteModal;

